<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->

<mat-nav-list appAccordion>
    <mat-list-item appAccordionLink *ngFor="let menuitem of menuData" routerLinkActive="selected"
        group="{{menuitem.Estado}}" (click)="scrollToTop()">

        <a class="" appAccordionToggle [routerLink]="['/', menuitem.Estado]" *ngIf="menuitem.type === 'link'" (click)="handleNotify()">
            <mat-icon>{{ menuitem.Icono }}</mat-icon>
            <span>{{ menuitem.Nombre | translate }}</span>
            <span fxFlex></span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
        </a>

        <a class="" appAccordionToggle href="{{menuitem.Estado}}" *ngIf="menuitem.type === 'extLink'">
            <mat-icon>{{ menuitem.Icono }}</mat-icon>
            <span>{{ menuitem.Nombre | translate }}</span>
            <span fxFlex></span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
        </a>

        <a class="" appAccordionToggle href="{{menuitem.Estado}}" target="_blank" *ngIf="menuitem.type === 'extTabLink'" >
            <mat-icon>{{ menuitem.Icono }}</mat-icon>
            <span>{{ menuitem.Nombre | translate}}</span>
            <span fxFlex></span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
        </a>

        <a class="" appAccordionToggle href="javascript:;" *ngIf="menuitem.type === 'sub'">
            <mat-icon>{{ menuitem.Icono }}</mat-icon>
            <span>{{ menuitem.Nombre | translate }}</span>
            <span fxFlex></span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
            <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
        </a>

        <mat-nav-list class="sub-item" *ngIf="menuitem.type === 'sub'">

            <mat-list-item *ngFor="let childitem of menuitem.children; let j=index; let i = childitem"
                routerLinkActive="selected">
                <a [routerLink]="['/', menuitem.Estado, childitem.Estado ]" *ngIf="childitem.type === 'link'"
                    class="relative" routerLinkActive="selected"
                    (click)="itemSelect[i]=j" (click)="handleNotify()">{{ childitem.Nombre | translate}}</a>
            </mat-list-item>

            <mat-list-item *ngFor="let childitem of menuitem.children; let j=index; let i=childitem; ">

                <a class="" href="javascript: void(0);" *ngIf="childitem.type === 'subchild'" (click)="addExpandClass(childitem.Nombre)" [ngClass]="{'selected' : showMenu === childitem.Nombre }">
                    <span>{{ childitem.Nombre | translate }}</span>
                    <span fxFlex></span>
                    <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
                </a>

                <mat-nav-list class="child-sub-item" *ngIf="childitem.type === 'subchild'">
                    <mat-list-item *ngFor="let child of childitem.subchildren" routerLinkActive="selected" >

                        <a [routerLink]="['/', menuitem.Estado, childitem.Estado, child.Estado ]"
                            routerLinkActive="selected">{{child.Nombre | translate}}</a>

                    </mat-list-item>
                </mat-nav-list>
                
            </mat-list-item>

        </mat-nav-list>

        <div class="saperator text-muted" *ngIf="menuitem.type === 'saperator'">
            <span>{{ menuitem.Nombre | translate }}</span>
        </div>
    </mat-list-item>
</mat-nav-list>
<app-version></app-version>